/**
 * Retro Video Filter
 * .filter-js を持つ要素に自動でエフェクトレイヤーを追加する
 *
 * 追加されるレイヤー:
 *  - .film-grain-canvas … フィルムノイズ（Canvas）
 *  - .fv-dot            … ハーフトーンドット（SVG feTurbulence）
 *  - .fv-vignette       … 周辺減光
 *  - .fv-scanline       … 走査線
 */
(function () {
	// ---- 設定 ----------------------------------------
	const TARGET_CLASS = 'filter-js';
	const FPS = 24; // フィルムグレイン fps
	const GRAIN_ALPHA = 255; // ノイズ濃度 0–255
	const DOT_SIZE = 10; // ドットの大きさ (px) — 大きいほど粗い
	// -----------------------------------------------------

	// ① SVGフィルター定義をbodyに1回だけ挿入
	function injectSvgDefs() {
		if (document.getElementById('fv-svg-defs')) return;
		const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		svg.id = 'fv-svg-defs';
		svg.classList.add('fv-svg-defs');
		svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
		svg.innerHTML = `
      <defs>
        <filter id="fv-halftone" x="0" y="0" width="100%" height="100%"
                color-interpolation-filters="sRGB">

          <!-- ドットのタイルパターン生成 -->
          <feTile>
            <feFuncR type="discrete" tableValues="0 1"/>
          </feTile>

          <!-- ノイズベースのドット -->
          <feTurbulence type="fractalNoise"
            baseFrequency="${(1 / (DOT_SIZE * 6)).toFixed(4)}"
            numOctaves="1" seed="2" result="noise"/>

          <feColorMatrix type="matrix"
            values="0 0 0 0 0
                    0 0 0 0 0
                    0 0 0 0 0
                    0 0 0 18 -7"
            in="noise" result="dotMask"/>

          <!-- ドットマスクをソース画像に合成 -->
          <feComposite in="SourceGraphic" in2="dotMask"
            operator="in" result="dotted"/>

          <feBlend in="dotted" in2="SourceGraphic" mode="multiply"/>
        </filter>
      </defs>
    `;
		document.body.prepend(svg);
	}

	// ② 各ラッパーにレイヤーを追加
	function addLayers(wrap) {
		// Film Grain Canvas
		const canvas = document.createElement('canvas');
		canvas.classList.add('film-grain-canvas');
		wrap.appendChild(canvas);

		// Halftone dot div
		const dot = document.createElement('div');
		dot.classList.add('fv-dot');
		wrap.appendChild(dot);

		// Vignette div
		const vig = document.createElement('div');
		vig.classList.add('fv-vignette');
		wrap.appendChild(vig);

		// Scanline div
		const scan = document.createElement('div');
		scan.classList.add('fv-scanline');
		wrap.appendChild(scan);

		// Film Grain アニメーション開始
		startGrain(canvas, wrap);
	}

	// ③ Film Grain 描画ループ
	function startGrain(canvas, wrap) {
		const ctx = canvas.getContext('2d');

		function drawFrame() {
			const w = wrap.offsetWidth;
			const h = wrap.offsetHeight;
			if (canvas.width !== w) canvas.width = w;
			if (canvas.height !== h) canvas.height = h;

			const img = ctx.createImageData(w, h);
			for (let i = 0; i < img.data.length; i += 4) {
				const v = Math.random() * 255 | 0;
				img.data[i] = v;
				img.data[i + 1] = v;
				img.data[i + 2] = v;
				img.data[i + 3] = GRAIN_ALPHA;
			}
			ctx.putImageData(img, 0, 0);

			setTimeout(
				() => requestAnimationFrame(drawFrame),
				1000 / FPS
			);
		}

		drawFrame();
	}

	// ---- エントリーポイント ----
	document.addEventListener('DOMContentLoaded', () => {
		injectSvgDefs();
		document
			.querySelectorAll('.' + TARGET_CLASS)
			.forEach(addLayers);
	});

})();
